import React, { useMemo } from "react";
import dayjs from "dayjs";
import { UI_DATE_FORMAT } from "../../../consts";
import { LoadingIcon } from "../../../components";
import { Table } from "antd";

const AnalysisTable = ({
  dateHeaders,
  showMetricColumn,
  analysisDataSource,
  tableLoading,
  expandedKeys,
  setExpandedKeys,
}) => {
  // Build columns
  const analysisColumns = useMemo(() => {
    const subsiteColumn = {
      title: "Subsite",
      dataIndex: "subsite",
      key: "subsite",
      render: (text, record) => {
        if (record.isLoading)
          return <div className="flex items-center gap-2">{text}</div>;
        if (record.isParent || record.isSummary) {
          return (
            <div
              className="font-semibold text-primaryBlue text-nowrap mr-16"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          );
        }
        return <div dangerouslySetInnerHTML={{ __html: text }} />;
      },
    };

    const metricColumn = {
      title: "Metrics",
      dataIndex: "detail",
      key: "detail",
      render: (text, record) => {
        if (record.isLoading) return null;
        return (
          <div
            className="whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        );
      },
    };

    const dateCols = dateHeaders.map((dh, idx) => ({
      title: dayjs(dh).format(UI_DATE_FORMAT),
      dataIndex: `day${idx}`,
      key: `day${idx}`,
      render: (value, record) => {
        if (record.isLoading) {
          return <LoadingIcon />;
        }
        return (
          <div
            className="whitespace-pre-wrap"
            dangerouslySetInnerHTML={{ __html: value }}
          />
        );
      },
    }));

    if (!showMetricColumn) {
      return [subsiteColumn, ...dateCols];
    }
    return [subsiteColumn, metricColumn, ...dateCols];
  }, [dateHeaders, showMetricColumn]);

  const analysisRowClassName = (record) => {
    let classes = "border-b border-gray-300 forecast-table";
    if (record.isParent) {
      classes += " border-t-2 border-gray-400 pt-2 ";
    }
    return classes;
  };

  const onExpandChange = (expanded, record) => {
    if (expanded) {
      setExpandedKeys((prev) => [...prev, record.key]);
    } else {
      setExpandedKeys((prev) => prev.filter((k) => k !== record.key));
    }
  };

  return (
    <Table
      loading={{
        spinning: tableLoading,
        indicator: <LoadingIcon />,
      }}
      columns={analysisColumns}
      dataSource={analysisDataSource}
      bordered={false}
      pagination={false}
      rowClassName={analysisRowClassName}
      onRow={(record) => {
        if (record.isSummary) {
          return { style: { backgroundColor: "#FFE699" } };
        }
        return {};
      }}
      expandable={{
        expandedRowKeys: expandedKeys,
        onExpand: onExpandChange,
      }}
    />
  );
};

export default AnalysisTable;
